module.exports = __webpack_public_path__ + "static/media/automated.56aa9d82.svg";